// import { lazy } from 'react';
import { AppProvider } from './context/AppContext';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ChatScreen from './component/ChatScreen';

const router = createBrowserRouter([
  {
    path: '/',
    element: <ChatScreen />,
  },
]);

function App() {
  return (
    <div className="w-screen root-bg min-h-screen h-fit">
      <AppProvider>
        <RouterProvider router={router}></RouterProvider>
        <ToastContainer />
      </AppProvider>
    </div>
  );
}

export default App;
